import type { ProjectTime } from "../components/Timing";
import { CalculateMinutesFromProjectTime } from "../interfaces/CapsuleEntry";
import type {
	CapsuleProject,
	CapsuleProjectResponse,
} from "../interfaces/CapsuleProject";
import type { ProjectSummary } from "../interfaces/ProjectSummary";
import { API, ParseCapsuleProjectResponse } from "./BaseAPI";

export const hoursInDay = 7;
export const hoursAllowedTag = 504197;
export const minutesUsedTag = 776438; //6707436
export const minutesRemainingTag = 776439; //6707437

export async function GetCapsuleProjects(pageNumber: number) {
	const response: {
		projects: ProjectSummary[];
		hasNextPage: boolean;
	} = {
		projects: [],
		hasNextPage: false,
	};

	const res = await API().get<CapsuleProjectResponse>(
		`/kases?perPage=100&embed=fields&page=${pageNumber}`,
		{
			method: "GET",
		},
	);

	const summary: ProjectSummary[] = [];

	if (res.data?.kases != null) {
		res.data.kases.forEach((r: CapsuleProject) => {
			const resp = ParseCapsuleProjectResponse(r);
			if (resp != null) {
				summary.push(resp);
			}
		});
	}

	response.projects.push(...summary);

	if (res.headers?.link != null) {
		response.hasNextPage = res.headers.link.includes('rel="next"');
	}

	return response;
}

export async function GetCapsuleProjectByID(id: number) {
	const res = await API().get<{ kase: CapsuleProject }>(
		`/kases/${id}?embed=fields`,
		{
			method: "GET",
		},
	);

	return res.data;
}

export async function PutCapsuleProjects(
	t: ProjectTime,
	project: ProjectSummary,
) {
	// Re-read the project summary in case it has changed whilst timing
	const resp = await GetCapsuleProjectByID(project.id);

	// Parse the project summary (supplying a forceDefault ensures non-undefined response)
	const projectSummary = ParseCapsuleProjectResponse(resp.kase, project);

	const minutes = CalculateMinutesFromProjectTime(t);

	const body = {
		kase: {
			fields: [
				{
					id:
						projectSummary.minutes_worked_id === 0
							? undefined
							: projectSummary.minutes_worked_id,
					definition: minutesUsedTag,
					value: (projectSummary.minutes_worked + minutes).toFixed(0),
				},
				{
					id:
						projectSummary.minutes_remaining_id === 0
							? undefined
							: projectSummary.minutes_remaining_id,
					definition: minutesRemainingTag,
					value: (
						(projectSummary.minutes_remaining === 0
							? projectSummary.allocated_days * 7 * 60
							: projectSummary.minutes_remaining) - minutes
					).toFixed(0),
				},
			],
		},
	};

	const res = await API().put(
		`/kases/${projectSummary.id}?embed=fields`,
		body,
		{
			method: "PUT",
		},
	);

	return res;
}
